module.exports = new __parcel__URL__("upfive.23f73aa6.png").toString();